import QueryBoundary from "components/QueryBoundary/QueryBoundary";
import { LogoSpinner } from "components/ui/Spinner";
import { useUser } from "contexts/UserContext";
import { EnhancedUser, hasRole } from "services/users/utils";
import { ForbiddenPage } from "pages/Error/ForbiddenPage";
import React from "react";
import { UserRole } from "services/users/model";

type Props = {
  Component: React.ComponentType;
  permissions?: Permissions;
  notAllowedElement?: React.ReactElement;
};

type Permissions = UserRole | UserRole[] | ((user: EnhancedUser) => boolean);

export default function RestrictedRoute({
  Component,
  permissions,
  notAllowedElement = <ForbiddenPage />,
}: Props) {
  const user = useUser();

  if (!hasPermissions(user, permissions)) {
    return notAllowedElement;
  }

  const fallback = (
    <div className="page-spinner-container">
      <LogoSpinner size="large" />
    </div>
  );

  return (
    <QueryBoundary fallback={fallback}>
      <Component />
    </QueryBoundary>
  );
}

const hasPermissions = (user: EnhancedUser, permissions?: Permissions) => {
  if (Array.isArray(permissions)) {
    return permissions.some(p => hasRole(p));
  } else if (typeof permissions === "string") {
    return hasRole(permissions);
  } else if (permissions) {
    return permissions(user);
  } else {
    return true;
  }
};
